import React, { useState } from 'react'
import styles from './CallbackForm.module.scss'
import axios from 'axios'

const CallbackForm = () => {
    const [formData, setFormData] = useState({
        name: '',
        phone: '',
        email: '',
        message: ''
    })
    const [successMessage, setSuccessMessage] = useState(''); 
    const handleSubmit = async (e) => {
        e.preventDefault();
        const scriptURL = "https://script.google.com/macros/s/AKfycbwHY_Nccpb97lYpeluqm05Y2uZwmQo2t_UGtSNEV_mLcNn4nvBFlzicygwU5hzLAyNfdA/exec"; 
        try {
            const response = await axios.post(scriptURL, formData, {
                headers: {
                    'Content-Type': 'text/plain',
                }
            });
            if (response?.status === 200) {
                console.log("success");
                setSuccessMessage("Thank you! We will get back to you soon.");
                setFormData({ name: '', email: '', phone: '', message: '' });
            } else {
                console.log("failed");
            }
        } catch (error) {
            setSuccessMessage("Thank you! We will get back to you soon.");
            console.error('Error::', error); //cors error is coming but data gets added in sheet will reolve later
        }
    };

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        })
    }
    return (
        <div className={styles.formContainer}>
            <form onSubmit={handleSubmit}>
                <div className={styles.form}>
                    <label>Name: </label>
                    <input type='text' name="name" placeholder='your name' value={formData?.name} onChange={handleChange}></input>
                </div>
                <div className={styles.form}>
                    <label>Phone: </label>
                    <input type="tel" name="phone" placeholder='your phone number' onChange={handleChange} value={formData?.phone}></input>
                </div>
                <div className={styles.form}>
                    <label>Email: </label>
                    <input type='text' name="email" placeholder='your email' onChange={handleChange} value={formData?.email}></input>
                </div>
                <div className={styles.form}>
                    <label>Message: </label>
                    <input type='text' name="message" placeholder='your message' onChange={handleChange} value={formData?.message}></input>
                </div>
                {/* will handle disabling part later */}
                <button type="submit" className={styles.formButton}>Submit</button> 
                {successMessage && (
                <div className={styles.successMessage}>
                    {successMessage}
                </div>
            )}
            </form>
            
        </div>

    )
}

export default CallbackForm